import { actionCreators } from '../../store/actions';
import ReduxActions from '../../store/ReduxActions';
import {
  PaymentIntent,
  PaymentOptionPayloadInterface,
  PaymentOptionPropertiesInterface,
  PaymentSetupIntent,
  PaymentSetupIntentPayload,
} from '../exports/Interfaces';
import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse, Response } from '../exports/Types';
import { PaymentMethod } from '../exports/Constants';

export type PaymentIntentBody = {
  company_id: number;
  payment_method_id: PaymentMethod;
  force_payment_method?: boolean;
};

export type GooglePayPaymentIntentBody = {
  company_id: number;
  amount: number;
};

class PaymentManager {
  public getPaymentOptions = async (companyId: number): Promise<DataWrappedResponse<PaymentIntent>> => {
    const request = await BackendApiClient.request({
      method: 'GET',
      url: '/payment-options',
      params: {
        company_id: companyId,
      },
    });
    const { success, response } = request;

    if (success) {
      ReduxActions.dispatch(actionCreators.paymentOptions.setPaymentOptions(response.data.data));
    }

    return request;
  };

  public createPaymentIntent = async (data: PaymentIntentBody): Promise<DataWrappedResponse<PaymentIntent>> =>
    BackendApiClient.request({
      method: 'POST',
      url: '/stripe/payment-intents',
      data,
    });

  public updatePaymentIntent = async (
    id: string,
    data: PaymentIntentBody,
  ): Promise<DataWrappedResponse<PaymentIntent>> =>
    BackendApiClient.request({
      method: 'PUT',
      url: `/stripe/payment-intents/${id}`,
      data,
    });

  removePaymentOption = async (id?: number) => {
    const request = await BackendApiClient.request({
      method: 'DELETE',
      url: `/payment-options/${id}`,
    });
    const { response, success } = request;

    if (success) {
      this.removePaymentOptionRedux(id, response.data.default_payment_option);
    }

    return request;
  };

  createPaymentOption = async (data: PaymentOptionPayloadInterface) => {
    const request = await BackendApiClient.request({
      method: 'POST',
      url: '/payment-options',
      data,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.dispatch(actionCreators.paymentOptions.addPaymentOption(response.data.data));
    }

    return request;
  };

  removePaymentOptionRedux = (id: number, newDefaultPaymentOption: PaymentOptionPropertiesInterface) => {
    const payload = {
      removePaymentOptionId: id,
      newDefaultPaymentOption,
    };
    const action = actionCreators.paymentOptions.removePaymentOption(payload);

    ReduxActions.dispatch(action);
  };

  public createPaymentSetupIntent = async (data: PaymentSetupIntentPayload): Promise<Response<PaymentSetupIntent>> =>
    BackendApiClient.request({
      method: 'POST',
      url: '/payment-setup-intents',
      data,
    });
}

export default new PaymentManager();
